import { $, $$ } from 'utils/dom';
import Swiperslider from 'modules/swiper/swiper';

const relatedContent = $$('.related-content');

if (relatedContent.length) {
  relatedContent.forEach(related => {
    const slider = new Swiperslider(
      $('.related-content__item-wrapper', related),
      {
        container: related,
        sliderOptions: {
          spaceBetween: 30,
        },
      }
    );
    slider.init();
  });
}
